import useSWR from 'swr'

import {
  fetchOrderConfirmationBanners,
  type OrderConfirmationBanner,
} from '@library/api-customer-engagement-experience'

type UseOrderConfirmationBannersResult = {
  data: OrderConfirmationBanner[] | undefined
  error: unknown
}

// Single owner of the banners request so every banner hook reads the same cache entry. Namespaced
// key avoids colliding with useOrderDeliveryDetails' bare-orderId cache entry; null key skips the
// fetch while orderId is the placeholder `false` OrderConfirmationContainer passes before the order
// loads; shouldRetryOnError/revalidateOnReconnect/revalidateOnFocus keep whichever outcome the
// first fetch lands on from later flipping a banner or its fallback.
export const useOrderConfirmationBanners = (orderId: string): UseOrderConfirmationBannersResult => {
  const { data, error } = useSWR(
    orderId ? ['order-confirmation-banners', orderId] : null,
    ([, id]) => fetchOrderConfirmationBanners(id),
    { shouldRetryOnError: false, revalidateOnReconnect: false, revalidateOnFocus: false },
  )

  return { data, error }
}
